import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import './css/inicio.css';
import Header from '../components/Header/header'; // Importamos el Header
import Slide from '../components/Card/ImageSlider';
import Footer from '../components/Footer/Footer';
import VerServicios from '../components/Card/VerServicios'
import { useWindowScroll } from '@uidotdev/usehooks';

const Inicio = () => {

  const [{ y }] = useWindowScroll();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (y > 700) {
      setScrollPosition(1);
    } else {
      setScrollPosition(0);
    }
  }, [y]);



  console.log("aaaaaaaaaa", headerHeight);

  return (
    <div className="contenedorInicio bg-elqui2">
      <Header  scrollPosition={scrollPosition} className="fixed-header" />
      <div className="cuerpo">
        {/* Pasamos el margen superior como propiedad al componente ImageSlider */}
        <Slide tipo="Inicio2"/>
        <div className='Servicios-Inicio' data-aos="fade-up">
          <VerServicios />
        </div>

        <div className='outer-div-Footer'>
          <Footer />
        </div> 
      </div>
    </div>
  );
};

export default Inicio;
